<div [formGroup]="pinForm">
    <div formArrayName="pin"
         class="pin-block"
    >
        @for (control of pinControls.controls; track control; let i = $index) {
            <input
                #pinInput
                [formControlName]="i"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                type="text"
                maxlength="1"
                inputmode="numeric"
                pattern="[0-9]*"
                aria-label="PIN digit {{ i + 1 }}"
            />
        }
    </div>
</div>
